export default "__VITE_ASSET__B15pLj1v__"